let availableLangs = ['EN', 'FR', 'NL', 'DE', 'ES', 'IT', 'PL'];

export function getCulture(countryCode: string) {
  if(availableLangs.includes(countryCode.toUpperCase())){
    return countryCode.toUpperCase();
  }

  // return German as default
  return 'DE';
}

export default {
  getCulture,
};
